import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import UnitTabHeader from './unit/unitTabHeader';
import CoachCourse from '../coachCourse/coachCourse.container';
import IeltsCourse from '../ielts/ieltsCourse.container';
import IWantToFilter from './iWantToFilter/iWantToFilter.container';
import Card from 'react-bootstrap/Card';
import LiveClass from '../liveClass/liveClass';
import Loader from '../../../utils/Loader';
import ProductsList from '../../buyCourse/productList'
import { getProductList } from '../../../redux/buyCourse/buyCourse.actions';
import YouTube from 'react-youtube';
// import AudioPlayer from './audioPlayer';
import IframeLoader from './iframeLoader';

const opts = {
	height: '390',
	width: '640',
	playerVars: {
		autoplay: 1,
		controls: 1,
		disablekb: 1,
		fs: 1,
		showinfo: 0,
		loop: 1,
		rel: 0,
		modestbranding: 1,
	},
};

const BuyCoachCourse = ({
	title,
	para,
	span,
	demo,
	contentTitle,
	content,
	demoLink,
	type,
}) => {
	const [showDemo, toggleDemo] = useState(false);

	useEffect(() => {
		if (showDemo && type === 'coach') {
			document.getElementById(`coachSampleAudio`).load();
		}
	}, [showDemo, type]);

	return (
		<div>
			<div className="buyCoachContainerNew">
				{title && <div className='alert alert-info mar-btm'>{title}</div>}

				{para && para.map((text) => {
					return (
						<p>{text}</p>
					)
				})}

				{span && <span>{span}</span>}

				<div className="buyCoachContent">
					<div className='sampleAudioContainer'>
						{(type === 'live' ? (
							<>
								<div className='sampleAudioTitle'>Watch a sample live class</div>
								<div className='buyCoachAudioContent'>
									<YouTube videoId="F7ud5DSobRU" opts={opts} />
								</div>
							</>
						) : (
							<>
								<div className='sampleAudioTitle'>Listen to sample coach calls</div>
								<div className='buyCoachAudioContent'>
									{demoLink.map((element, elementIndex) => {
										return (
											<div className='audioCard'>
												<div className={`audioCardPoster audioCardPoster-${elementIndex}`}></div>
												<div className='audioCardContent'>
													<h1>{element.title}</h1>
													<IframeLoader
														id={elementIndex}
														src={element.link}
													/>
												</div>
											</div>
										)
									})}
								</div>
							</>
						))}
					</div>
				</div>

			</div>
		</div>
	);
};

const Detail = React.memo(function Detail({ activeTabType, isCoachCourse, courseType, courseid, addedGrants, getProductList }) {
	const [elementFilter, setElementFilter] = useState(
		sessionStorage.getItem('filterApplied') || 'Any',
	);

	const userOrgID = localStorage.getItem('orgID');

	useEffect(() => {
		sessionStorage.setItem('filterApplied', elementFilter);
	}, [elementFilter]);

	useEffect(() => {
		getProductList();
		Loader.hide();
	}, [getProductList]);

	const ListFiller = {
		online: {
			title: `Sorry! You haven't bought any courses with Online Lessons.`,
			demo: `You can access a FREE demo course here!`,
			contentTitle: `What are Online Lessons?`,
			content: `Many of STEP's courses have Online Lessons, which comprise Webisodes, Tests and Adaptive elements. Webisodes are lessons with a video, followed by questions based on the video. Every course has a Baseline Test to understand your current level, and the Adaptive elements (more webisodes) are decided on the basis of this test. Some courses also have mid-line tests to assess your levels in between, and also certification tests at the end to award you certificates from The Hindu Group! These lessons will be accessible on Web and Android App, and you'll be able to access all webisodes any number of times without any restrictions. `,
		},
		live: {
			title: `Your current course does not include live classes.`,
			para: ['Live classes are live, online lessons with a trainer. During a live class, you interact with the trainer, ask and answer questions through chat/polls and complete practice exercises online'],
			demoLink: 'https://www.youtube.com/watch?v=F7ud5DSobRU?rel=0',
		},
		coach: {
			title: `Your current course does not include coach calls.`,
			para: ['Coach calls are one-on-one calls with an expert trainer, who is assigned as your very own English coach! Coach calls are personalised based on your language level, and requirements.'],
			demoLink: [
				{
					title: 'Unlimited - English for general communication',
					link: 'https://live2.steptest.in/playback/presentation/2.3/615880b8bb5a40639a96243e93f4ed585050f9e2-1650535222529'
				},
				{
					title: 'Unlimited - English for working professional',
					link: 'https://live2.steptest.in/playback/presentation/2.3/ef9532be87554ef38ed76cb1b8d4719e8fe5c715-1681551008949'
				},
				{
					title: 'Unlimited - English for exam prep',
					link: 'https://live2.steptest.in/playback/presentation/2.3/dc7ba0683bd6eee3b682e09067fb9b47bd15b422-1675245612023'
				},
				{
					title: 'Unlimited - English for IELTS',
					link: 'https://live2.steptest.in/playback/presentation/2.3/dd665974b75c7edb0122909271994c1ce56d6780-1644812658732'
				}
			],
		},
	};

	return (
		<Card>
			<Card.Body className="unitsContainer">
				{activeTabType === 'coachcalls' ? (
					addedGrants?.coach !== false ? (
						<CoachCourse />
					) : (
						<>
							<BuyCoachCourse
								{...ListFiller['coach']}
								type='coach'
							/>
							<div className='alert alert-warning mar-top' role='alert'>Learn more about courses with coach calls.</div>
							<ProductsList showonly='coach' />
						</>
					)
				) : activeTabType === 'liveclass' ? (
					addedGrants?.live_v2 !== false ? (
						<LiveClass />
					) : (
						<>
							<BuyCoachCourse
								{...ListFiller['live']}
								type='live'
							/>
							<div className='alert alert-warning mar-top' role='alert'>You can purchase the course(s) below to access live classes.</div>
							<ProductsList showonly='live' />
						</>
					)
				) : (
					<div>
						{courseid === 507 ? (
							<IeltsCourse />
						) : null}
						<Card className="border-0 ">
							<Card.Header className="unitsHeader justify-flex-end">
								{courseType !== 'live' && courseid !== 507 && (
									<IWantToFilter
										setElementFilter={setElementFilter}
										elementFilter={elementFilter}
									/>
								)}
							</Card.Header>
							<Card.Body>
								<UnitTabHeader elementFilter={elementFilter} />
							</Card.Body>
						</Card>
					</div>
				)}
			</Card.Body>
		</Card>
	);
});

// const Detail = ({ activeTabType, isCoachCourse, courseType, courseid }) => {
// 	const [elementFilter, setElementFilter] = useState(
// 		sessionStorage.getItem('filterApplied') || 'Any',
// 	);

// 	useEffect(() => {
// 		sessionStorage.setItem('filterApplied', elementFilter);
// 	}, [elementFilter]);

// 	return (
// 		<Card>
// 			<Card.Body className="unitsContainer">
// 				{activeTabType === 'coachcalls' ? (
// 					<CoachCourse />
// 				) : activeTabType === 'liveclass' ? (
// 					<LiveClass />
// 				) : (
// 					<div>
// 						{courseid === 507 ? (
// 							<IeltsCourse />
// 						) : null}
// 						<Card className="border-0 ">
// 							<Card.Header className="unitsHeader">
// 								<h4>Table of Content</h4>
// 								{courseType !== 'live' && courseid !== 507 && (
// 									<IWantToFilter
// 										setElementFilter={setElementFilter}
// 										elementFilter={elementFilter}
// 									/>
// 								)}
// 							</Card.Header>
// 							<Card.Body>
// 								<UnitTabHeader elementFilter={elementFilter} />
// 							</Card.Body>
// 						</Card>
// 					</div>
// 				)}
// 			</Card.Body>
// 		</Card>
// 	);
// };

const mapStateToProps = (state) => {
	const { isCoachCourse, courseType, courseid, addedGrants } = state.rootReducer.myCourse;
	return {
		isCoachCourse,
		courseType,
		courseid,
		addedGrants,
	};
};

const mapDispatchToProps = (dispatch) => {
	return {
		getProductList: () => dispatch(getProductList()),
	};
};

export default compose(connect(mapStateToProps, mapDispatchToProps))(Detail);
